import { SelectItem } from 'primeng/api/selectitem';
import {EquipmentUsedDuringRepair} from './equipmentUsedDuringRepair'
import { Data } from '@angular/router';
export class CreateTicketFormFields
{
    //Common Fields
    public isValidTicketUser?:boolean=true;  //set false for void ticket also
    public isNewTicket?:boolean=true;
    public ticketNumber?:string=null;
    public TicketId?:number=null;
    public ticketMaxDate:Date=new Date();
    public ticketMinDate:Date=new Date((new Date().setDate(new Date().getDate()-45)));
    public dateClosed:string=new Date().toString();
    public ticketStatusId?:number=null;
    public ticketSavedByFullName:string="";
    public ticketSavedByFirstLastName:string="";
    //Labour Section & Alert section
    public isShowColumn2:boolean=false;
    public isShowColumn3:boolean=false;
     
    public isLocationBoxDisabled:boolean=false;
    public selectedDivisionId?:number=null;
    public selectedDivisionName?:string=null;
    public selectedRegionId?:number=null;
    public selectedRegionName?:string=null;
    public selectedFacilityId?:number=null;
    public selectedFacilityName?:string=null;
    //Batch section
    public isBatchTicket?: boolean = false;
    public batchRadioButtonselectedValue?: Number = null;
    public selectedBatchId?: number = null;
    public seletedBatchName?: string = null;
    public isCanBatchFlag?: boolean = false;
    public isCloneFlag?: boolean = null;
    public hasclock?:number=1;
    //Service Type Section
    public ScheduledRadioButtonselectedValue?: string = null
    public selectedWorkTypeId?: Number = null
    public selectedWorkTypeName?: string = null
    public isServiceTypeBoxDisabled:boolean=false;
    //Equipment Being Serviced
     public selectedEquipmentList?:any=null;
     //Serice Requested Date Box
     public isDateServiceRequestedDisabled:boolean=false;
     public srRequestedDate?:string=null;  //sr=>Service Requested Date
     public srBeginDate?:string=null
     public srCompletedDate?:string=null  //dateServicePerformed
     //Aler Section
     public selectedpayRollId?:number=0;
     public selectedpayRollName?:string=null;
     public selectedSQACodeId?:number=0;
     public selectedSQACodeName?:string=null;
     public isSQACodeDisabled:boolean=false;
     public selectedSQASubCodeId?:number=0;
     public selectedSQASubCodeName?:string=null;
     public selectedQuestionId?:number=0;
     public selectedQuestionName?:string=null;


     public ispartsUsedRadio?:string=null;
     public ispartsUsedRadioDisabled?:boolean=true;
     public partTotalAmount:string='0';
     public istestEquipUsedRadio?:string=null;
     public ismeritComplaint?:string=null;
     public responseComment?:string='';
     public lastRecordedHours?:number=0;
     public clockHours?:number;
     //Alert Box
     public alertBox?:string="";
    public isAlertBoxInactive:boolean=true;
     //Labor Section
     public serviceRequested?:string="";
     public findings?:string="";
     public isServiceMatchFindingsFlag?:string=null;
     public workPerformed?:string="";
     public totalHours?:number=0;
     public totalMinutes?:number=0;
     public hoursWorkedSel?:number;
     public minutesWorkedSel?:number;
     public hoursTravelSel?:number;
     public minutesTravelSel?:number;
     //EquipmentID
     public SelectedEquipmentID?:number;
    //Parts Used Duering repair

    public partsUsedDuringRepair?: buildingUsedRepair[]=null;
    //TestEquipmentRepair Used Duering repair
    public testEquipmentUsedDuringRepair?:EquipmentUsedDuringRepair[]=null;
     //Void
     public voidReason?:string='';
     public voidClosedReason?:string=''
     public voidCloseClone?:boolean=false
    //Ticket Summary
    public isShowTicketSummary:boolean=false;
    public isShowBatchTicketSummary:boolean=false;
    public isEquipmentReleasedForTreatmentFlag:number=null;
    public showSignatureLine:boolean=false;
    public isTSCloseButtonShow:boolean=false; //TS=: Ticket Summary
    public isTSCommonButtonShow:boolean=false;
    public isTSVoidButtonShow:boolean=false;
    public btnHideCloseTicketSummary:boolean=false;
    public isReleaseEquipRadioDisabled:boolean=false;
    //BatchTicket Fields
    public batchDetails:Batch=null;
    public selectedBatchEquipmentList:any[]=null;
    public batchTicketObj:SaveBatchTicket[]=null  //Save BatchTicket Object
    public isShowBatchLabour:boolean=false;
    public batchMeasure:BatchMeasure[]=null
    public batchPart:BatchPart[]=null
    public isShowAdditionalComment=false;
    public additionalComment:string="";
    public showCurrentTemplate:boolean=false;
    public testComponent:string= 'SW'  //SW-SotwareUpdate,EC-ElectricalSafety CA-:CovidAttes
    public selectedBatchEquipmentData:any[]=null;
}
export class addUnlistedPart {
    manufacturerId?: number;
    partNumber?: string;
    manufacturerName?: string = '';
    partDescription?: string = '';
    unitPrice?: number;
    adHocValid?: boolean = true;
}
export class buildingUsedRepair {
    quantity: number = 1;
    partId?: number;
    partNumber?: string;
    manufacturerName?: string;
    partDescription?: string;
    originalUnitCost?: number;
    unitCost?: number;
    dateOfInstall?: string;
    isPartUnderWarranty: number = -1;
    rgaNumber?: string;
    showRgaOptions?: number = -1;
    ticketPartSourceId?: number;
    isReplacingWarrantyPartFlag?: boolean = false;
    isRGAQualifiedFlag?: boolean = false;
    zeroCost?: boolean = false;
}

//Batch Ticket Classes
export class Batch 
{
    BatchId?: number;
    BatchName?: string;
    BatchDescription?: string;
    WorkTypeId?: number;
    SQACodeId?: number;
    SQASubCodeId?: number;
    ServiceRequested?: string;
    Findings?: string;
    WorkPerformed?: string;
    isActiveFlag?: number;
    EquipmentTypeId?: number;
    EquipmentSubTypeId?: any;
    effectiveDate?: any;
    expirationDate?: any;
    payrollCodeId?: number;
    ManufacturerId?: any;
    ModelId?: any;
}
export class BatchMeasure {
    batchId?: number;
    discreteMeasureId?: number;
    discreteMeasureAttributeId?: number;
    discreteMeasureTypeId?: number;
    minValue?: any;
    maxValue?: any;
    minDate?: any;
    maxDate?: any;
    answer?: number;
    discreteMeasureTypeDesc?: string;
    discreteMeasureAttributeDesc?: string;
}

export class SaveBatchTicket 
{
    sqaCode?: number=null;
    networkSurveyA?: any=null;
    networkSurveyC?: any=null;
    networkSurveyB?: any=null;
    networkSurveyE?: any=null;
    isServiceMatchFindingsFlag: number=null;
    networkSurveyD?: any=null;
    dateServiceBegan?: Date=null;
    equipmentId?: number=null;
    sqaSubCodeId?: any=null;
    serviceRequested: string=null;
    clockHours?: any=null;
    dateServiceRequested?: Date=null;
    dateServicePerformed?: Date=null;
    waterFrequency?: any=null;
    groundWireResistance?: any=null;
    workTypeId: number=null;
    batchId?: number=null;
    electricalLeakage?: any=null;
    hoursWorkPerTicket?: string=null;
    ticketStatusId?: number=null;
    ticketId?: number=null;
    payrollCodeId?: number=null;
    manufacturerName?: string=null;
    ticketNumber?: string=null;
    waterTemperatureVolume?: any=null;
    waterTemperature?: any=null;
    hoursTravel?: number=null;
    isUnscheduledFlag?: any=null;
    additionalComments?: any=null;
    workPerformed?: string=null;
    facilityMasterId?: number=null;
    waterVolume?: any=null;
    isBatchFlag?: number=null;
    hoursWork?: number=null;
    equipmentSerialNumber?: string=null;
    hoursTravelPerTicket?: string=null;
    waterVolumeMonthly?: any=null;
    totalHoursPerTicket?: string=null;
    waterDurationA?: any=null;
    waterDurationB?: any=null;
    isCloneFlag?: number=null;
    waterDurationE?: any=null;
    waterDurationC?: any=null;
    waterDurationD?: any=null;
    meritComplaint?: number=null;
    ticketCount?: any=null;
    isScheduledFlag?: number=null;
    modelDescription?: string=null;
    covidAttestationA?: any=null;
    covidAttestationB?: any=null;
    covidAttestationC?: any=null;
    GeneralSoftware?: string=null;
    Actuator?: string=null;
    Functional?: string=null;
}

export class BatchPart {
    batchPartId?: number;
    batchId?: number;
    partId?: number;
    quantity?: number;
    partDescription?: string;
    partNumber?: string;
    unitCost?: number;
    manufacturerName?: string;
}

export class SelectedBatchEquipment
{
    EquipmentID: number;
    LocationName?: any;
    ModelID: number;
    EquipmentSerialNumber: string;
    DateOfOriginalInstall: Date;
    DateOfLastRepair?: Date;
    DateModified: Date;
    LastClockHours?: number;
    clockhours?: number;
    DateWarrantyExpires: Date;
    DateOfLastPM?: Date;
    isCustomScheduleActiveFlag: number;
    ModelDescription: string;
    modelNumber: string;
    EquipmentTypeID: number;
    EquipmentSubTypeID: number;
    ManufacturerID: number;
    hasClock: number;
    hasClockText: string;
    ManufacturerName: string;
    EquipmentTypeDescription: string;
    EquipmentSubTypeDescription: string;
    modifiedby: number;
    equipmentDescription: string;
    GeneralSoftwareVersion: string;
    ActuatorVersion: string;
    FunctionalVersion: string;
    status: string;
    equipmentstatusid: number;
    electricalLeakageMax?: number;
    groundWireResistanceMax?: number;
    SoftwareVersion: string;
}
